import { connect } from "react-redux";
import { forwardRef } from "react";
const connectAndForwardRef = (mapStateToProps = null, mapDispatchToProps = null, mergeProps = null, options = {}) => component => connect(mapStateToProps, mapDispatchToProps, mergeProps, Object.assign(Object.assign({}, options), { forwardRef: true }))(forwardRef(component));
export default connectAndForwardRef;
